<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >

    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-upload"
            font-scale="4"
        />
        <div class="mb-3">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>

  <b-card
    title="گزارش سگمنت ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      autocomplete="off"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="IsBaseSegment"
                >
                  <v-select
                      id="IsBaseSegment"
                      v-model="filterOptions.IsBaseSegment"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      input-id="IsBaseSegment"
                      :clearable="true"
                      :options="segmentType"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
        >
          <template #cell(LastCount)="data">
            <span>{{ data.value | price }}</span>
          </template>

          <template #cell(IsBaseSegment)="data">
            <span>{{ data.value ? 'سگمنت پایه' : 'سگمنت اختصاصی' }}</span>
          </template>

          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <feather-icon
                  icon="BarChartIcon"
                  size="16"
                  @click="showReport(data)"
              />
            </div>
          </template>
          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
    <segment-report-item :show.sync="showReportModal" :data="row" />
  </b-overlay>
</template>
<script>
import { BIcon, BIconArchiveFill, BIconArchive } from 'bootstrap-vue'
import segmentReportItem from "@/views/menu/notification/segmentReportItem.vue";
import NotificationReport from "@/views/menu/notification/notificationReport.vue";

export default {
  name: 'SegmentReports',
  components: {NotificationReport, BIcon, BIconArchiveFill, BIconArchive, segmentReportItem },
  data() {
    return {
      filterOptions: {
        PerPage: 10,
        Page: 1,
        Title: null,
        IsBaseSegment: null,
      },
      totalRows: 1000 * 1000,
      loading: false,
      processing: false,
      showReportModal: false,
      row: null,
      counter: 1,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'LastCount',
          label: 'آخرین تعداد',
        },
        {
          key: 'IsBaseSegment',
          label: 'سگمنت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      segmentType: [
        { value: true, text: 'سگمنت پایه' },
        { value: false, text: 'سگمنت اختصاصی' }
      ],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    archive(archive, row) {
      this.$http.post(this.$api.segmentCustom.setArchive, {
        Id: row.item.Id,
        IsArchive: archive,
      }).then(() => { this.update() })
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.segmentReports.getList, this.filterOptions)
        .then(response => {
          this.loading = false
          this.items = response.data
          this.items = this.items.map(item => {
            this.$set(item, 'sampleUser', { } )
            this.$set(item, 'getSampleUserLoading', false)
            return item
          })
          this.totalRows = response.totalRow
        })
    },
    remove(id) {
      this.removeRow(this.$api.segmentCustom.remove, 'Id', id)
    },
    exportExcel(id){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = id + '.xlsx'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("POST", '/api/segment/export-excel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify({
        'Id': id
      }))
    },
    showReport(row) {
      this.showReportModal = true
      this.row = {
        isBaseSegment: row.item.IsBaseSegment,
        id: row.item.Id,
        title: row.item.Title,
      }
    }
  },
}
</script>
